import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Container,
  Title,
  CardsGrid,
  Card,
  CardCorner,
  CardTitle,
  StyledLink,
} from './EducationBlock.style';

import card1Src from '../../assets/images/education/education_type_1.jpg';
import card2Src from '../../assets/images/education/education_type_2.jpg';
import card3Src from '../../assets/images/education/education_type_3.jpg';
import card4Src from '../../assets/images/education/education_type_4.jpg';

export const EducationBlock = () => {
  const intl = useIntl();

  return (
    <Root>
      <Container>
        <Title>
          <FormattedMessage defaultMessage="Explore & Redeem" />
        </Title>
        <CardsGrid>
          <Card to="/education/business-education">
            <img
              src={card1Src}
              alt={intl.formatMessage({ defaultMessage: 'Business Education' })}
            />
            <CardCorner
              xmlns="http://www.w3.org/2000/svg"
              width={33}
              viewBox="0 0 67 60"
            >
              <path d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z" fill="#e74391"></path>
            </CardCorner>
            <CardTitle>
              <FormattedMessage
                defaultMessage="Business{br}Education"
                values={{ br: <br /> }}
              />
            </CardTitle>
            <StyledLink style={{ color: '#e74391' }}>
              <FormattedMessage defaultMessage="Get Started" />
            </StyledLink>
          </Card>
          <Card to="/education/in-salon-classes">
            <img
              src={card2Src}
              alt={intl.formatMessage({ defaultMessage: 'In-Salon Classes' })}
            />
            <CardCorner
              xmlns="http://www.w3.org/2000/svg"
              width={33}
              viewBox="0 0 67 60"
            >
              <path d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z" fill="#9457a3"></path>
            </CardCorner>
            <CardTitle>
              <FormattedMessage
                defaultMessage="In-Salon{br}Classes"
                values={{ br: <br /> }}
              />
            </CardTitle>
            <StyledLink style={{ color: '#9457a3' }}>
              <FormattedMessage defaultMessage="Get Started" />
            </StyledLink>
          </Card>
          <Card to="/education/in-salon-artist-classes">
            <img
              src={card3Src}
              alt={intl.formatMessage({
                defaultMessage: 'In-Salon Artist Classes',
              })}
            />
            <CardCorner
              xmlns="http://www.w3.org/2000/svg"
              width={33}
              viewBox="0 0 67 60"
            >
              <path d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z" fill="#533fa4"></path>
            </CardCorner>
            <CardTitle>
              <FormattedMessage
                defaultMessage="In-Salon{br}Artist Classes"
                values={{ br: <br /> }}
              />
            </CardTitle>
            <StyledLink style={{ color: '#533fa4' }}>
              <FormattedMessage defaultMessage="Get Started" />
            </StyledLink>
          </Card>
          <Card to="/education/education-on-demand">
            <img
              src={card4Src}
              alt={intl.formatMessage({
                defaultMessage: 'Education On Demand',
              })}
            />
            <CardCorner
              xmlns="http://www.w3.org/2000/svg"
              width={33}
              viewBox="0 0 67 60"
            >
              <path d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z" fill="#e1000f"></path>
            </CardCorner>
            <CardTitle>
              <FormattedMessage defaultMessage="Education On Demand" />
            </CardTitle>
            <StyledLink style={{ color: '#e1000f' }}>
              <FormattedMessage defaultMessage="Get Started" />
            </StyledLink>
          </Card>
        </CardsGrid>
      </Container>
    </Root>
  );
};
